const {Component} = require("react");
const PropTypes = require("prop-types");
const ProductList = require("app/components/products/ProductList");
const Paginator = require("app/components/lists/Paginator");
const Loader = require("app/components/mixins/Loader");
const productsApi = require("app/pipelines/products-api");
const {animateBodyScrollToAnchorElement} = require("app/util/animateScroll");

class List extends Component {

	static get propTypes() {
		return {
			group: PropTypes.any,
			items: PropTypes.array,
			pagination: PropTypes.object,
			noItemsText: PropTypes.string,
			scrollAnchorSelector: PropTypes.string,
			scrollOffset: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			group: null,
			items: [],
			pagination: null,
			noItemsText: translate("Ingen produkter fundet."),
			scrollOffset: 0
		}
	}

	constructor(props) {
		super(props);

		this.state = {
			items: props.items,
			pagination: props.pagination,
			loading: false
		};
	}

	componentDidMount() {
		// hook to pipelines
		productsApi.request.pipe(payload => {
			// Set state to loading
			this.setState({loading: true});

			payload.with_unavailable = 1;

			if (this.props.group) {
				payload.group = this.props.group;
			}

			// reset page
			if (!payload.$page) {
				payload.$page = 1;
			}

			return payload;
		});

		productsApi.response.capture(payload => {
			this.setState({
				items: payload.collection,
				pagination: payload.pagination,
				loading: false
			});

			return payload;
		});
	}

	get className() {
		let classList = ["dynamic-product-list"];

		if (this.state.loading) {
			classList.push("loading");
		}

		return classList.join(" ");
	}

	_onPageChange = (page) => {
		productsApi.request.dispatch({$page: page}).then(() => {
			animateBodyScrollToAnchorElement(
				this.props.scrollAnchorSelector,
				this.props.scrollOffset
			);
		});
	};

	renderPaginator() {
		if (this.state.pagination && (this.state.pagination.pages > 1)) {
			return (
				<Paginator page={this.state.pagination.page} pages={this.state.pagination.pages} onChange={this._onPageChange}/>
			);
		}
	}

	renderList() {
		if (this.state.items.length > 0) {
			return (
				<ProductList items={this.state.items}/>
			);
		}

		return (
			<div className="no-items">{this.props.noItemsText}</div>
		);
	}

	render() {
		return (
			<div className={this.className}>
				<div className="body">
					<Loader active={this.state.loading}/>
					{this.renderList()}
				</div>
				{this.renderPaginator()}
			</div>
		);
	}
}

module.exports = List;
